export default {
  name: 'instagramfeed',
  type: 'layout'
}
